import React, { useState } from 'react';
import { KeyRound } from 'lucide-react';
import { toast } from 'sonner';
import { api, formatApiError } from '../../lib/api';
import { useT } from '../../context/LanguageContext';
import { fieldCls, labelCls } from './ProfileForm';

export const PasswordForm = ({ user, onUpdated }) => {
  const { t } = useT();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 6) return toast.error(t('Nytt passord må vera minst 6 teikn'));
    if (next !== confirm) return toast.error(t('Passorda er ikkje like'));
    setSaving(true);
    try {
      await api.post('/users/me/password', { current_password: user.has_password ? current : null, new_password: next });
      toast.success(t(user.has_password ? 'Passordet er endra' : 'Passord er lagt til'));
      setCurrent(''); setNext(''); setConfirm('');
      onUpdated({ ...user, has_password: true });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="password-form">
      {user.has_password ? (
        <div>
          <label className={labelCls}>{t('Noverande passord')}</label>
          <input data-testid="password-current-input" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} className={fieldCls} required />
        </div>
      ) : (
        <p className="text-white/50 text-sm">{user.is_admin ? t('Opprett passordet du brukar saman med adminnummeret på /admin_console.') : `${t('Du er logga inn')} ${t(user.auth_provider === 'magic' ? 'med e-postlenke' : 'med Google')}. ${t('Legg til eit passord for å også kunne logge inn med e-post og passord.')}`}</p>
      )}
      <div>
        <label className={labelCls}>{t('Nytt passord')}</label>
        <input data-testid="password-new-input" type="password" value={next} onChange={(e) => setNext(e.target.value)} className={fieldCls} required minLength={6} />
      </div>
      <div>
        <label className={labelCls}>{t('Gjenta nytt passord')}</label>
        <input data-testid="password-confirm-input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={fieldCls} required minLength={6} />
      </div>
      <button type="submit" data-testid="password-save-button" disabled={saving} className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border-2 border-[#ff2e2e] text-[#ff2e2e] font-bold uppercase tracking-wide hover:bg-[#ff2e2e] hover:text-black transition-colors disabled:opacity-60">
        <KeyRound size={16} /> {saving ? t('Lagrar…') : t(user.has_password ? 'Byt passord' : 'Legg til passord')}
      </button>
    </form>
  );
};
